import React from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import './style.scss'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

const CreateCampaign = () => {
    const navigate = useNavigate()
    const manualCreationAllowedConfig = useSelector((state: RootState) => state.auth.configurations.agency_manual_campaign_allowed);
    const manualCreationAllowed = manualCreationAllowedConfig === 'y';
    const modeCount = manualCreationAllowed ? 3 : 2;

    const handleManualBuild = () => {
        navigate('/campaign/create')
    }

    const handleAiBuild = () => {
        navigate('/campaign/create/ai-auto')
    }

    const handleAiBriefBuild = () => {
        navigate('/campaign/create/ai-brief')
    }

    return (
        <div className="page-content">
            <div className="page-content-inner page-spacing">
                <div className="new-campaign-creation-mode">
                    <div className='new-campaign-creation-mode-header'>
                        <div className="d-flex flex-column justify-content-center align-items-center gap-2">
                            <h1 className="new-campaign-creation-mode-title">How do you want to build your campaign?</h1>
                            <p className='new-campaign-creation-mode-description'>
                                Choose to craft every detail yourself, or let AI analyze your profile and generate a data-backed strategy.
                            </p>
                        </div>
                    </div>

                    <div className={`new-campaign-creation-mode-cards new-campaign-creation-mode-cards--${modeCount}`}>
                        {
                            manualCreationAllowed && (
                                <button
                                    type="button"
                                    className="new-campaign-creation-card"
                                    onClick={handleManualBuild}
                                >
                                    <div className="new-campaign-creation-card__icon" aria-hidden="true">
                                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="11.9167" y="8.25" width="20.1667" height="27.5" rx="5.5" stroke="#26345D" strokeWidth="2.75" />
                                            <path d="M16.5 14.6667H27.5" stroke="#26345D" strokeWidth="2.75" strokeLinecap="round" />
                                            <path d="M16.5 20.1667H22" stroke="#26345D" strokeWidth="2.75" strokeLinecap="round" />
                                            <path d="M16.5 25.6667H19.25" stroke="#26345D" strokeWidth="2.75" strokeLinecap="round" />
                                            <path d="M27.5 8.25V19.25" stroke="#26345D" strokeWidth="2.75" strokeLinecap="round" />
                                            <path d="M32.0833 14.6667H22.9167" stroke="#26345D" strokeWidth="2.75" strokeLinecap="round" />
                                        </svg>
                                    </div>

                                    <div className="new-campaign-creation-card__content">
                                        <div className="new-campaign-creation-card__copy">
                                            <h2 className="new-campaign-creation-card__title">Build Manually</h2>
                                            <p className="new-campaign-creation-card__description">
                                                Full control. Set your own audience, creators, brief, and every campaign detail from scratch.
                                            </p>
                                        </div>

                                        <span className="new-campaign-creation-card__eyebrow">For experienced marketers</span>
                                    </div>
                                </button>
                            )
                        }
                        <button
                            type="button"
                            className="new-campaign-creation-card"
                            onClick={handleAiBriefBuild}
                        >
                            <div className="new-campaign-creation-card__icon" aria-hidden="true">
                                <svg xmlns="http://www.w3.org/2000/svg" width="54" height="58" viewBox="0 0 54 58" fill="none">
                                    <path d="M10.5 25.3337C10.5 18.4197 10.5 14.9628 12.6479 12.8149C14.7958 10.667 18.2527 10.667 25.1667 10.667H28.8333C35.7473 10.667 39.2042 10.667 41.3521 12.8149C43.5 14.9628 43.5 18.4197 43.5 25.3337V32.667C43.5 39.5809 43.5 43.0379 41.3521 45.1858C39.2042 47.3337 35.7473 47.3337 28.8333 47.3337H25.1667C18.2527 47.3337 14.7958 47.3337 12.6479 45.1858C10.5 43.0379 10.5 39.5809 10.5 32.667V25.3337Z" stroke="#111111" stroke-width="2.75" />
                                    <path d="M19.666 25.333H34.3327" stroke="#111111" strokeWidth="2.75" strokeLinecap="round" />
                                    <path d="M19.666 32.667H28.8327" stroke="#111111" strokeWidth="2.75" strokeLinecap="round" />
                                    <path d="M46.3994 12.3779C45.6023 10.0437 43.7559 8.19779 41.4219 7.40039C43.7558 6.60312 45.6021 4.7568 46.3994 2.42285C47.1968 4.75692 49.0427 6.60329 51.377 7.40039C49.0426 8.19763 47.1966 10.0436 46.3994 12.3779Z" fill="url(#paint0_linear_4309_2510)" stroke="#FFCFDE" strokeWidth="0.857951" />
                                    <path d="M7.39941 55.3779C6.60231 53.0437 4.75595 51.1978 2.42188 50.4004C4.75582 49.6031 6.60215 47.7568 7.39942 45.4229C8.19682 47.7569 10.0427 49.6033 12.377 50.4004C10.0426 51.1976 8.19665 53.0436 7.39941 55.3779Z" fill="url(#paint1_linear_4309_2510)" stroke="#FFCFDE" strokeWidth="0.857951" />
                                    <defs>
                                        <linearGradient id="paint0_linear_4309_2510" x1="47.0157" y1="11.7165" x2="39.8214" y2="2.87786" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#FFABC2" />
                                            <stop offset="0.461569" stopColor="#FF4360" />
                                            <stop offset="0.694356" stopColor="#FF267D" />
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_4309_2510" x1="8.01565" y1="54.7165" x2="0.821374" y2="45.8779" gradientUnits="userSpaceOnUse">
                                            <stop stopColor="#FFABC2" />
                                            <stop offset="0.461569" stopColor="#FF4360" />
                                            <stop offset="0.694356" stopColor="#FF267D" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>

                            <div className="new-campaign-creation-card__content">
                                <div className="new-campaign-creation-card__copy">
                                    <h2 className="new-campaign-creation-card__title">Build with Brief</h2>
                                    <p className="new-campaign-creation-card__description">
                                        AI generates campaign ideas based on your Brief.
                                    </p>
                                </div>

                                <span className="new-campaign-creation-card__eyebrow">Based on your Brief</span>
                            </div>
                        </button>
                        <button
                            type="button"
                            className="new-campaign-creation-card"
                            onClick={handleAiBuild}
                        >
                            <div className="new-campaign-creation-card__icon" aria-hidden="true">
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.9014 8.73047L20.4477 13.5523C20.8919 14.9377 21.9783 16.024 23.3636 16.4683L28.1854 18.0146L23.3636 19.5609C21.9783 20.0051 20.8919 21.0915 20.4477 22.4769L18.9014 27.2987L17.3551 22.4769C16.9108 21.0915 15.8245 20.0051 14.4391 19.5609L9.61731 18.0146L14.4391 16.4683C15.8245 16.024 16.9108 14.9377 17.3551 13.5523L18.9014 8.73047Z" fill="#FF5A69" />
                                    <path d="M31.271 18.9316L32.0612 21.3944C32.3071 22.1607 32.9079 22.7616 33.6743 23.0075L36.137 23.7977L33.6743 24.5879C32.9079 24.8337 32.3071 25.4346 32.0612 26.2009L31.271 28.6637L30.4808 26.2009C30.235 25.4346 29.6341 24.8337 28.8678 24.5879L26.405 23.7977L28.8678 23.0075C29.6341 22.7616 30.235 22.1607 30.4808 21.3944L31.271 18.9316Z" fill="#FF5A69" />
                                </svg>
                            </div>

                            <div className="new-campaign-creation-card__content">
                                <div className="new-campaign-creation-card__copy">
                                    <h2 className="new-campaign-creation-card__title">Build with AI</h2>
                                    <p className="new-campaign-creation-card__description">
                                        AI analyzes your brand profile and generates data-backed strategies with pre-built campaigns.
                                    </p>
                                </div>

                                <span className="new-campaign-creation-card__eyebrow">Smart · Fast · Strategic</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateCampaign